import React, {useEffect, useRef, useState} from "react";
import "./compare.scss";
import Navbar from "../nav/Navbar";
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import BuildMissingCompetitors from "./CompetitorContainer/BuildMissingCompetitors";
import PrimaryVehicle from "./CompetitorContainer/PrimaryVehicle";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";

import {
    activeFeatureName,
    fetchTrimData,
    getActiveFeatureCategory,
    getActiveIndex,
    getCarouselIndexKey,
    getCategoriesName,
    getClientprofile,
    getFeartureSearched,
    getFeatuerSearch,
    getFeatureLabel,
    getPrimaryandSecondaryVehicles,
    getTrimModels,
    getVehicleIndex,
    PostcompareData,
    searchMake,
    searchMakeCodes,
    secondarySearch,
    secondaryYears,
    VehicleIndex,
    setActiveLanguage,
    setActiveLocale,
    setAdvantagesCheck,
    setCheckedFeature,
    setSecondariesMake,
    secondaryVehiclesTrims,
    getVehicleTypesName,
    clearCompareData,
    exterirorColorCode,
    getVehicleTypes,
    setButtonHandlerText,
    buttonHandler,
    setRemovedVehicle,
    clearPhotoStates,
    isFetureNavigate,
    setVehicleInfo,
    vehicleInfo,
    getSecondarYvehicle,
    setColorIcon,
    setCompareGroupData,
    setCompareDataGroupInfo,
    getSegmentsByFilter,
    getSelectedPriceRange,
    defaultMinPrice,
    defaultMaxPrice,
    setColorName,
    setBaseGroup,
    storeLockedVehicles,
    storeLockedCompetitors,
    setDifferenceOnly,
    setCategories,
    setSecondaryYears,
    isLoading,
    sendErrorMessage,
    setErrorCode,
    hideDisclaimer,
    updateVehicleOrder,
    vehicleHasSwapped,
    swapCompareImages,
    setTrimVehiclesData,
    setHeaderLoadType,
    getAdvantagesCheck,
    setAllAdvantage,
} from "../../slices/vehicleSlice";
import {useDispatch, useSelector} from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import {Change} from "./Change";
import {Color} from "./Color";
import BasicModal from "../Modal/BasicModal";
import MediaQuery, {useMediaQuery} from "react-responsive";
import FeatureTable from "./FeatureTable";
import FilterToolbar from "./FilterToolbar";
import {currencyConverter, priceFormatter} from "../../utility/methods";
import {
    getKeyByValue
} from "./change.method";
import InfoIcon from '@mui/icons-material/Info';
import {Carousel} from "react-bootstrap";
import {
    addTrimSeparator,
    checkLockStatus,
    competitorLength,
    getCompareGroupData,
    getCompetitorImages,
    getIccCode,
    handleChangeModalClose,
    removeTrimSeparator,
    resetOverviewPanelStyles,
    setImageStyles, setOverviewPanelStyles,
    setVehicleDetailStyles,
    showMobileNav,
    showSingleFeature,
    toggleLockStatus
} from "./compare.method";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {NavbarBtn} from "../nav/NavbarBtn";
import {getActiveLanguage} from "../vehicle/vehicle.utility";
import StickyNavbar from "./stickyNavbar";
import {
    trackAdvantagesChecked,
    trackAdvantagesUnChecked,
    trackCollapseAllHandler,
    trackExpandAllHandler,
    trackFeatureBenefitHyperLink,
    trackFeatureSearchInput,
    trackNavigateToNewCompare,
    trackNavigateToPhotos,
    trackPageViewEngagement,
    trackRemovedVehicle,
    trackSelectSecondaryVehicle,
    trackVehiclePositionChanged,  trackCompareCompetitors, trackCompareTrims
} from "../GoogleTagManager.utils";
import {getColorName} from "./color.methods";
import LockCompetitor from "../Button/LockCompetitor";
import Loader from "../Loader/Loader";
import SecondaryCompetitors from "./CompetitorContainer/SecondaryCompetitors";
import CarouselCompetitor from "./CompetitorContainer/CarouselCompetitor";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import FirstCompetitor from "./CompetitorContainer/FirstCompetitor";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUpDownLeftRight} from "@fortawesome/free-solid-svg-icons";
import LandscapeCompetitorView from "./CompetitorContainer/LandscapeCompetitorView";


const Compare = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const {t} = useTranslation();
    const {code} = useParams();
    const isMobile = useMediaQuery({query: '(max-width: 479px)'})
    const isDesktop = useMediaQuery({query: '(min-width: 899px)'})
    const minMobile = useMediaQuery({query: '(min-width: 479px)'})
    const maxTablet = useMediaQuery({query: '(max-width: 899px)'})
    const maxMobileHeight = useMediaQuery({ query: '(max-height: 568px)' })
    const maxMobileLandScapeHeight = useMediaQuery({ query: '(max-height: 568px)' })
    const maxLaptopHeight = useMediaQuery({ query: '(max-height: 769px)' })
    let trimCodes = useSelector(secondaryVehiclesTrims)
    const setFeatureLabel = useSelector(getFeatureLabel);
    const vehiclesTrim = useSelector(getTrimModels);
    const activeFeatureLabel = useSelector(activeFeatureName)
    const secondaryYear = useSelector(setSecondaryYears);
    const previousTrimCodesRef = useRef([]);
    const vehiclesMakes = useSelector(setSecondariesMake);
    const vehicleModels = useSelector(searchMakeCodes);
    const vehicleIndex = useSelector(VehicleIndex);
    const defaultAdvantageChecked = useSelector(getAdvantagesCheck);
    const secondaryVehicle = useSelector(getSecondarYvehicle)
    const baseGroup = useSelector(setBaseGroup);
    const isFeatureChecked =  sessionStorage.getItem('isFeatureChecked') === 'true';
    const isAdvantageChecked = defaultAdvantageChecked ? defaultAdvantageChecked : sessionStorage.getItem('isCheckedAdvantages') === 'true';
    const isDifferenceOnly = sessionStorage.getItem('isDifferenceOnly') === 'true';
    const expandHandlerText = t('features.searchBar.collapseAll')
    const collapseHandlerText = t('features.searchBar.expandAll')
    dispatch(setCheckedFeature(isFeatureChecked));
    dispatch(setAdvantagesCheck(isAdvantageChecked));
    dispatch(setDifferenceOnly(isDifferenceOnly))
    const searchedFeature = useSelector(getFeartureSearched);
    const activeLocale = useSelector(setActiveLocale)
    const setPrimaryAndSecondaryVehicles = useSelector(getPrimaryandSecondaryVehicles);
    const activeVehicleIndex = useSelector(getActiveIndex)
    const vehicleTypeName = useSelector(getVehicleTypesName);
    const vehicleTypes = useSelector(getVehicleTypes)
    const colorCode = useSelector(exterirorColorCode)
    const buttonHandlerText = useSelector(buttonHandler)
    const getVehicleInfo = useSelector(vehicleInfo);
    const min = useSelector(defaultMinPrice)
    const max = useSelector(defaultMaxPrice)
    const loading = useSelector(isLoading);
    const {pathname} = window.location;
    const [open, setOpen] = React.useState(false);
    const [showNav, setShowNav] = React.useState(false);
    const [buttonClicked, setButtonClicked] = React.useState(false);
    const [vehicleData, setVehicleData] = React.useState(null);
    const [description, setDescription] = React.useState("");
    const [title, setTitle] = React.useState("");
    let [isExpanded, setAlwaysOpen] = React.useState(false);
    const [expandedArr, setExpandedArr] = React.useState([]);
    const [checked, setChecked] = React.useState(false);
    const [openModal, setOpenModal] = React.useState(false);
    const [openOptionsModal, setOptionsModal] = React.useState(false)
    const [addedEquipment, showAddedEqu] = React.useState("")
    const [vehicleModel, setVehicleModel] = React.useState("");
    const [vehicleMake, setVehicleMake] = React.useState("");
    const [trimModel, setTrimModel] = React.useState("");
    const [hideDiv, setHideDiv] = React.useState(true);
    const [ driveType, setDriveType] = React.useState("")
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [featureLabel, setFeatureLabelName] = useState(null);
    const [changeOptions, setChangeOptions] = useState(null);
    const [vehicleName, setVehicleName] = useState(null);
    const [isFixed, setIsFixed] = React.useState(false);
    const [trimIndex, setTrimIndex] = useState(null);
    const [featureVehicleLocked, setFeatureVehicleLocked] = useState(null);
    const [category, setCategoryName] = useState(null);
    const [featureValue, setFeatureValue] = useState(null);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [tooltipText, setTooltipText] = useState('');
    const [hideButtons, setHideButtons] = React.useState(false);
    const [tooltipLoading, setTooltipLoading] = useState(false);
    const allAdvantage = useSelector(setAllAdvantage);
    const headerLoadType = useSelector(setHeaderLoadType);
    const [hideImages, setHideImages] = React.useState(() => {
        if (window.innerHeight <= 769) {
            return window.scrollY > 250;
        }
        return false;
    });
    const isMountedRef = useRef(true);
    const setSecondaryVehicles = [...setPrimaryAndSecondaryVehicles];
    const compareGroup = useSelector(setCompareDataGroupInfo)
    const featuresLabel = useSelector(getCategoriesName);
    const isLocked = useSelector(storeLockedCompetitors);
    const errorCode = useSelector(setErrorCode);
    const hasDisclaimer = useSelector(hideDisclaimer);
    const handleReload = () => {
        dispatch(setRemovedVehicle({primaryChanged: false}));
    }

    const handleToggle = (index, vehicle) => {
        toggleLockStatus(index, vehicle, isLocked, dispatch, storeLockedVehicles, compareGroup);
    };

    const displayModal = (options,label,index,vehicle, value, categoryName) => {
        setVehicleName(setPrimaryAndSecondaryVehicles[index]?.description);
        setFeatureLabelName(label);
        setTrimIndex(index);
        setChangeOptions(options);
        setFeatureVehicleLocked(vehicle);
        setFeatureValue(value);
        setCategoryName(categoryName);
        setIsModalVisible(true);
    }
    const hideModal = () => {
        setIsModalVisible(false);
        setFeatureLabelName(null);
        setChangeOptions(null);
        setVehicleName(null);
        dispatch(setTrimVehiclesData([]));
    }

    useEffect(() => {
        dispatch((setCompareGroupData({
            primaryVehicleDescription: setPrimaryAndSecondaryVehicles[0]?.description,
            secondaryOneVehicleDescription: setPrimaryAndSecondaryVehicles[1] ? setPrimaryAndSecondaryVehicles[1].description : null,
            secondaryTwoVehicleDescription: setPrimaryAndSecondaryVehicles[2] ? setPrimaryAndSecondaryVehicles[2].description : null,
            secondaryThreeVehicleDescription: setPrimaryAndSecondaryVehicles[3] ? setPrimaryAndSecondaryVehicles[3].description : null,
            primaryVehicleMSRP: setPrimaryAndSecondaryVehicles[0]?.pricing.msrp,
            secondaryOneVehicleMSRP: setPrimaryAndSecondaryVehicles[1] ? setPrimaryAndSecondaryVehicles[1].pricing.msrp : null,
            secondaryTwoVehicleMSRP: setPrimaryAndSecondaryVehicles[2] ? setPrimaryAndSecondaryVehicles[2].pricing.msrp : null,
            secondaryThreeVehicleMSRP: setPrimaryAndSecondaryVehicles[3] && setPrimaryAndSecondaryVehicles[3] && setPrimaryAndSecondaryVehicles[2]
                ? setPrimaryAndSecondaryVehicles[2].pricing.msrp
                : null,
            primaryVehicleYear: setPrimaryAndSecondaryVehicles[0]?.year,
            primaryVehicleTrim: setPrimaryAndSecondaryVehicles[0]?.trim,
            primaryVehicleMake: setPrimaryAndSecondaryVehicles[0]?.make,
            primaryVehicleModel: setPrimaryAndSecondaryVehicles[0]?.model,
            errorCode: errorCode
        })))
    }, [setPrimaryAndSecondaryVehicles ,setFeatureLabel,activeLocale])


    const handleOpen = () => {
        setOpen(true)
        trackFeatureBenefitHyperLink(compareGroup)
    };
    const handleClose = () => setOpen(false);
    const handleScroll = () => {
        const navbar = document.querySelector(".feature-segment-label");
        const footer = document.querySelector(".footer-jdpa");

        const setNavbarStyle = (position, top = "", paddingTop = "", height = "",zIndex = "") => {
            if (!navbar) return;
            navbar.style.position = position;
            navbar.style.top = top;
            navbar.style.paddingTop = paddingTop;
            navbar.style.height = height;
            navbar.style.zIndex = zIndex;
            navbar.style.display = "flex";
        };

        const hideNavbar = () => {
            setHideDiv(true);
            if (!navbar) return;
            navbar.style.position = "relative";
            navbar.style.display = "none";
        };

        if (footer && navbar) {
            const footerRect = footer.getBoundingClientRect();
            const navbarRect = navbar.getBoundingClientRect();
            const featureList = document.querySelector(".feature-list");

            if (featureList) {
                const featureRect = featureList.getBoundingClientRect();

                if (featureRect.bottom <= 0) {
                    navbar.style.display = "none";
                    return;
                }

                if (featureRect.bottom > 0 && footerRect.top > navbarRect.bottom) {
                    navbar.style.display = "flex";
                }
            }
            if (footerRect.top < navbarRect.bottom) {
                navbar.style.display = "none";
                return;
            } else {
                navbar.style.display = "flex";
            }
        }

        if (isMobile && !maxMobileHeight) {
            if (window.pageYOffset <= 680) {
                hideNavbar();
            } else if (window.pageYOffset >= 700) {
                setHideDiv(false);
                setNavbarStyle("fixed", "100px");
            }
        } else if (maxMobileHeight) {
            if (window.scrollY <= 526) {
                hideNavbar();
            } else if (window.scrollY >= 540) {
                setHideDiv(false);
                setNavbarStyle("fixed", "0", "10px", "50px","2");
            }
        } else if (maxLaptopHeight){
            if (window.scrollY >= 140) {
                setHideDiv(false);
            } else {
                hideNavbar();
            }
        }

        else {
            if (!maxLaptopHeight && window.pageYOffset <= 119) {
                hideNavbar();
            } else if (!maxLaptopHeight && window.pageYOffset >= 120) {
                setHideDiv(false);
            }
        }
    };

    const setCurrentVehicleID = (id) => {
        return id;
    }

    useEffect(() => {
        window.addEventListener("scroll", handleScrolls);
        return () => {
            window.removeEventListener("scroll", handleScrolls);
        };
    }, []);

    const handleScrolls = () => {
        if (minMobile && maxTablet)
        {
            const scrollY = window.scrollY;
            const navbar = document.querySelector(".navbar-overview");
            const featurePanelCategory = document.querySelector(".feature-panel-category");
            const navbarPosition = document.querySelector(".navbar-position")

            if (maxMobileHeight) {
                navbar.style.position = "relative";
            } else {
                if (!maxMobileHeight && scrollY <= 50 || scrollY === 0) {
                    setIsFixed(true);
                    navbar.style.position = "revert";
                    featurePanelCategory.style.marginTop = "0";
                } else if (scrollY >= 50) {
                    setIsFixed(true);
                    navbar.style.top = "50px";
                    navbarPosition.style.position = "sticky"
                    navbar.style.position = "sticky";
                }
            }
        }
    };

    const handleChange = (panel) => async (event, newExpanded) => {
      dispatch(setCategories({ panel, newExpanded }));
    };

    const compareTrim = () => {
        dispatch(setColorIcon(null))
        dispatch(storeLockedVehicles(null))
        const country = props.country ? `/${props.country}` : '';
        const lng = props.language === 'en' ? '' : `/${props.language}`
        sessionStorage.removeItem('isArrayFilled');
        sessionStorage.removeItem("selectedTrim");
        dispatch(clearCompareData())
        dispatch(setCategories({ removeAll: true }))
        dispatch(setCheckedFeature(false));
        dispatch(setAdvantagesCheck(true));
        dispatch(getFeatuerSearch(null));
        dispatch(clearPhotoStates())
        dispatch(setTrimVehiclesData([]));
        sessionStorage.removeItem("isTrimSelected");
        dispatch(sendErrorMessage({error:'',errorCode: null}))
        navigate(`/${props.client}${country}${lng}/vehicle/`);
        sessionStorage.removeItem('compareData')
        !!min && !!max && dispatch(getSelectedPriceRange([min, max]));
        dispatch(getSegmentsByFilter({clearData:true}))
        trackNavigateToNewCompare(compareGroup)
        sessionStorage.removeItem('loadPrimaryOnReload');
        sessionStorage.removeItem("competitorsRemoved");
    }
    const navigatePhotos = () => {
        dispatch(sendErrorMessage({error:'',errorCode: null}))
        dispatch(setRemovedVehicle({remove:true}));
        dispatch(swapCompareImages({ swapTriggered: false }));
        dispatch(setTrimVehiclesData([]));
        const updatedTrimCodes = trimCodes.filter((code) => code !== undefined);
        const trimCodesStr = updatedTrimCodes.slice(1).join('-');
        const effectiveCode = code !== undefined ? code : updatedTrimCodes[0];
        let countryPath = '';
        if (props.country) {
            countryPath = props.country + '/';
        }
        if (props.language !== 'en') {
            countryPath = countryPath + props.language + '/';
        }
        let url = `/${props.client}/${countryPath}compare/photos/${updatedTrimCodes[0]}/${trimCodesStr}/`;
        if (props.client === 'jdpa') {
            url = `/cars/compare-cars/${countryPath}compare/photos/${updatedTrimCodes[0]}/${trimCodesStr}/`;
        }

        const secondaryVehicles = []
        const vehicleCodes = []
        setPrimaryAndSecondaryVehicles.map((vehicleCode) => {
            if (vehicleCode) {
                vehicleCodes.push(vehicleCode);
                secondaryVehicles.push({ code: vehicleCode?.code });
            }

        });

        setPrimaryAndSecondaryVehicles.length === 1
            ? sessionStorage.setItem("competitorsRemoved", "true")
            : sessionStorage.removeItem("competitorsRemoved");

        navigate(url, {replace: true});
        trackNavigateToPhotos(compareGroup)
    }

    const areArraysEqual = (arr1, arr2) => {
        if (arr1?.length !== arr2?.length) return false;
        for (let i = 0; i < arr1?.length; i++) {
            if (arr1[i] !== arr2[i]) return false;
        }
        return true;
    };

    const changeHandler = async (id, vehicle) => {
        if (vehicle?.length === 0) {
            setVehicleModel(null);
            setTrimModel(null);
            setDriveType(null)
            setVehicleMake(null);
            setVehicleData(null)
        }
        setButtonClicked(true)
        setCurrentVehicleID(id);
        await setVehicleData(vehicle? vehicle : null)
        dispatch(getVehicleIndex(id));
        await setOpenModal(true);
        trackSelectSecondaryVehicle(compareGroup)
    };

    useEffect(()=>{
        dispatch(secondaryYears())
    },changeHandler)

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        if (window.location.pathname.includes('/us/')) {
            const newUrl = window.location.pathname.replace('/us/', '/');
            window.history.replaceState({}, '', newUrl);
        }
    }, []);

    useEffect(() => {
        if (previousTrimCodesRef.current?.length === 0 || !areArraysEqual(trimCodes, previousTrimCodesRef.current)) {
            previousTrimCodesRef.current = trimCodes;

            const isSameMake = setPrimaryAndSecondaryVehicles.every(
                (vehicle) => vehicle?.make === setPrimaryAndSecondaryVehicles[0]?.make
            );

            if (!isSameMake) {
                dispatch(setDifferenceOnly(false));
                dispatch(setCheckedFeature(false));
                dispatch(setAdvantagesCheck(true));
            } else if (setPrimaryAndSecondaryVehicles.length === 1) {
                dispatch(setCheckedFeature(false));
                dispatch(setDifferenceOnly(false));
                dispatch(setAdvantagesCheck(false));
            } else {
                dispatch(setDifferenceOnly(true));
                dispatch(setCheckedFeature(false));
                dispatch(setAdvantagesCheck(false));
            }
        }
    }, [trimCodes]);

    useEffect(() => {
        try {
            const storedIsExpanded = sessionStorage.getItem('isExpanded');
            const storedExpandedArr = JSON.parse(sessionStorage.getItem('expandedArr'));

            if (storedIsExpanded !== null) {
                setAlwaysOpen(storedIsExpanded === 'true');
            }

            if (isMountedRef.current) {
                if (storedIsExpanded === 'false') {
                    setExpandedArr(featuresLabel);
                } else if (storedIsExpanded === 'true') {
                    setExpandedArr([]);
                }

                if (storedExpandedArr !== null && storedExpandedArr.length > 0) {
                    setExpandedArr(storedExpandedArr);
                } else {
                    if (!sessionStorage.getItem('isArrayFilled') && featuresLabel.length > 0) {
                        setExpandedArr(featuresLabel);
                        sessionStorage.setItem('expandedArr', JSON.stringify(featuresLabel));
                    }
                }
            }
        } catch (error) {
            console.error(error);
        }
    }, []);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (isMobile) return;
        if (maxMobileLandScapeHeight) return ;
        function handleScroll() {
            const competitorOverviews = document.querySelectorAll('.competitor-vehicle-overview');
            const noVehicleDivs = document.querySelectorAll('.competitor-vehicle-overview .no-vehicle');
            const noCompetitors = competitorOverviews.length > 0 && competitorOverviews.length === noVehicleDivs.length;

            if (maxLaptopHeight) {
                const height = noCompetitors ? (window.scrollY === 0 ? 'revert-layer' : '100px') : (window.scrollY > 0 ? 'auto' : '180px');
                document.querySelectorAll('.competitor-vehicle-overview').forEach(child => {
                    child.style.height = height;
                });

                if (noCompetitors) {
                    document.querySelector('.feature-container').style.maxHeight = window.scrollY < 50 ? '210px' : '70px';
                }
            }
            if (!maxLaptopHeight) return;
            const scrollTop = window.scrollY;
            if (!maxLaptopHeight) return;

            const firstScroll = 100, secondScroll = 250;

            function setPrimaryVehicleImages(show) {
                document.querySelectorAll('.primary-vehicle img').forEach(img => {
                    img.style.display = show ? 'block' : 'none';
                    if (show) {
                        img.style.height = 'auto';
                        img.style.width = 'auto';
                    }
                });
            }

            if (noCompetitors) {
                if (scrollTop === 0) {
                    setHideImages(false);
                    setHideButtons(false);
                    setPrimaryVehicleImages(true);
                    document.querySelector('.feature-container').style.maxHeight = '210px';
                    setImageStyles();
                    setVehicleDetailStyles('14px', false);
                    resetOverviewPanelStyles();
                    removeTrimSeparator();
                } else if (scrollTop > 0 && scrollTop <= firstScroll) {
                    setHideImages(true);
                    setHideButtons(true);
                    setPrimaryVehicleImages(false);
                    setOverviewPanelStyles();
                    removeTrimSeparator();
                    setVehicleDetailStyles('14px', true);
                } else if (scrollTop > secondScroll) {
                    setHideImages(true);
                    setHideButtons(true);
                    setOverviewPanelStyles();
                    setVehicleDetailStyles('14px', true);
                    addTrimSeparator();
                    setImageStyles('', '', 'none');
                }
            } else {
                if (scrollTop === 0) {
                    setHideImages(false);
                    setHideButtons(false);
                    setImageStyles();
                    setVehicleDetailStyles('14px', false);
                    resetOverviewPanelStyles();
                    removeTrimSeparator();
                } else if (scrollTop > 0 && scrollTop <= firstScroll) {
                    setHideImages(false);
                    setHideButtons(true);
                    const progress = scrollTop / firstScroll;
                    const scale = 1 - 0.5 * progress;
                    const opacity = 1 - 0.5 * progress;
                    const translateY = -50 * progress;
                    resetOverviewPanelStyles();
                    removeTrimSeparator();
                    setImageStyles(`scale(${scale}) translateY(${translateY}px)`, opacity);
                } else if (scrollTop > secondScroll) {
                    setHideImages(true);
                    setHideButtons(true);
                    setOverviewPanelStyles();
                    setVehicleDetailStyles('14px', true);
                    addTrimSeparator();
                    setImageStyles('', '', 'none');
                }
            }
        }

        const handleResize = () => {
            if (window.innerHeight <= 769) {
                setHideImages(window.scrollY > 250);
            } else {
                setHideImages(false);
            }
            setHideButtons(false);
            setImageStyles();
            setVehicleDetailStyles('14px', false);
            resetOverviewPanelStyles();
            removeTrimSeparator();
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };

    }, [maxLaptopHeight, isMobile, maxMobileLandScapeHeight]);

    useEffect(() => {
        const handleOrientationChange = () => {
            window.location.reload();
        };

        window.addEventListener('orientationchange', handleOrientationChange);

        return () => {
            window.removeEventListener('orientationchange', handleOrientationChange);
        };
    }, []);

    useEffect(() => {
        if (isMobile ) return;
        if (maxMobileLandScapeHeight) return ;

        function updateImageVisibility() {
            if (maxLaptopHeight) {
                if (window.scrollY < 180) {
                    document.querySelectorAll('.primary-vehicle img, .competitor-vehicle img').forEach(img => {
                        img.style.visibility = 'visible';
                    });
                } else {
                    document.querySelectorAll('.primary-vehicle img, .competitor-vehicle img').forEach(img => {
                        img.style.visibility = 'hidden';
                    });
                }
            } else {
                document.querySelectorAll('.primary-vehicle img, .competitor-vehicle img').forEach(img => {
                    img.style.visibility = 'visible';
                });
            }
        }

        updateImageVisibility();
        if (!maxMobileLandScapeHeight) {
            window.addEventListener('scroll', updateImageVisibility);
            window.addEventListener('resize', updateImageVisibility);

            return () => {
                window.removeEventListener('scroll', updateImageVisibility);
                window.removeEventListener('resize', updateImageVisibility);
            };
        }
    }, [maxLaptopHeight,  isMobile, maxMobileLandScapeHeight]);

    useEffect(() => {
        if (!maxLaptopHeight && isDesktop) {
            setTimeout(() => {
                document.querySelectorAll('.competitor-vehicle-overview').forEach(child => {
                    maxLaptopHeight ? child.style.height = '140px' : child.style.height = '210px';
                });
            }, 0);
            const primaryVehicle = document.querySelector('.primary-vehicle');
            if (primaryVehicle && maxLaptopHeight){
                primaryVehicle.style.borderRight = '1px solid #cccccc';
            }
            else if (primaryVehicle){
                primaryVehicle.style.borderRight = '';
            }
            setHideImages(false);
            setHideButtons(false);
            setImageStyles();
            setVehicleDetailStyles('14px');
            resetOverviewPanelStyles(maxLaptopHeight);
            removeTrimSeparator();
        }
    }, [maxLaptopHeight, isDesktop]);

    useEffect(() => {
        if (isMountedRef.current) {
            if (isExpanded) {
                setExpandedArr([]);
                sessionStorage.setItem('isExpanded', 'true');
                sessionStorage.setItem('expandedArr', JSON.stringify([]));
            }
        } else {
            setExpandedArr(featuresLabel);
            sessionStorage.setItem('isExpanded', 'false');
            sessionStorage.setItem('expandedArr', JSON.stringify(featuresLabel));
        }

    }, [isExpanded, featuresLabel, isExpanded]);

    useEffect(() => {

        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(()=> {
        if(buttonHandlerText === null) {

           dispatch(setButtonHandlerText(expandHandlerText))
       }
    }, [buttonHandlerText])
    let isUnmounted = false;
    useEffect(()=> {
        const Feature = window.location.pathname.includes('features')
       dispatch(isFetureNavigate({Feature:Feature}))
    },[setPrimaryAndSecondaryVehicles])

    async function dispatchAndTrackCompareData(compareData, akanaAppId, profileKey) {
        const result = await dispatch(PostcompareData(compareData, { akanaAppId, profileKey }));
        const isTrimSelected = JSON.parse(sessionStorage.getItem("isTrimSelected"));
        const error = result?.payload?.statusCode
        if (!result?.error && result.payload?.vehicles) {
            const newCompareGroup = getCompareGroupData(result.payload.vehicles, error, compareGroup);
            dispatch(setCompareGroupData(newCompareGroup));
            if (typeof isTrimSelected === "boolean") {
                isTrimSelected ? trackCompareTrims(newCompareGroup) : trackCompareCompetitors(newCompareGroup);
            }
        }
    }

   async function loadCompareData(akanaAppId, profileKey, supportedLanguages, data) {
        const storedData = sessionStorage.getItem('loadPrimaryOnReload');
        if (storedData && Object.keys(isLocked).length > 0) {
            const parsedData = JSON.parse(storedData);
            if (!isUnmounted && Object.keys(isLocked).length < 1){
                await dispatchAndTrackCompareData(parsedData, akanaAppId, profileKey);
                dispatch(setRemovedVehicle(null))
                const LOCALE = getActiveLanguage(props.language, supportedLanguages);
                dispatch(setActiveLanguage(LOCALE));
                trackPageViewEngagement(baseGroup, LOCALE);
                dispatch(secondaryYears);
            }
        } else {
            await dispatchAndTrackCompareData(data, akanaAppId, profileKey);
            dispatch(secondaryYears);
        }
        const LOCALE = getActiveLanguage(props.language, supportedLanguages);
        dispatch(setActiveLanguage(LOCALE));
        trackPageViewEngagement(baseGroup, LOCALE)
        dispatch(secondaryYears);
    }

    function handleCompareDataLoad({ isReload = false }) {
        if (isReload && sessionStorage.getItem('isReload') !== 'true') return;
        if (!code) {
            return;
        }
        let data = {};
        let codes = [];
        if (code) {
            codes = [{code: code}];
            if (props.codes) {
                const codesArray = props.codes.split('-');
                codesArray.forEach((code) => {
                    codes.push({
                        code: code,
                    });
                });
            }

             data = {
                exterior: colorCode ? colorCode : null,
                code: codes
            };

            let akanaAppId = sessionStorage.getItem('akanaAppId');
            let profileKey = sessionStorage.getItem('profileKey');
            let supportedLanguages = sessionStorage.getItem('supportedLanguages');

            if (akanaAppId === null || profileKey === null || supportedLanguages === null){
                dispatch(getClientprofile(props)).then((result) => {
                    if (!result.payload) return;
                    akanaAppId = result.payload.akanaAppId;
                    profileKey = result.payload.profileKey;
                    supportedLanguages = result.payload.supportedLanguages;
                    loadCompareData(akanaAppId, profileKey, supportedLanguages, data);
                });
            }else{
                supportedLanguages = supportedLanguages.split(",");
                loadCompareData(akanaAppId, profileKey, supportedLanguages, data);
            }
        }
        dispatch(setTrimVehiclesData([]));
        if (isReload) {
            sessionStorage.removeItem('competitorsRemoved');
            sessionStorage.removeItem('isReload');
        }
    }


    useEffect(() => {
        handleCompareDataLoad({ isReload: true });
    }, []);

    useEffect(() => {
        if (!code) {
            dispatch(setTrimVehiclesData([]));
            const supportedLanguages = sessionStorage.getItem('supportedLanguages') ? sessionStorage.getItem('supportedLanguages').split(',') : [];
            const LOCALE = getActiveLanguage(props.language, supportedLanguages);
            dispatch(setActiveLanguage(LOCALE));
            return;
        }
        handleCompareDataLoad({ isReload: false });
    }, [props.client, props.language, props.client, activeLocale, code]);

    useEffect(() => {
        if (trimCodes && trimCodes.length > 0 && trimCodes[0]) {
            const [newCode, ...newTrimCodes] = trimCodes;
            const definedTrimCodes = newTrimCodes.filter((code) => code !== undefined);
            const trimCodesStr = definedTrimCodes.join('-');
            const urlParts = window.location.pathname.split('/');
            const featuresIndex = urlParts.indexOf('features');

            if (featuresIndex !== -1 && featuresIndex < urlParts.length - 1) {
                const code = urlParts[featuresIndex + 1];
                const codes = urlParts.slice(featuresIndex + 2).join('-');

                const isCodeChanged = code !== newCode;
                const isCodesChanged = codes !== trimCodesStr;

                if (isCodeChanged || isCodesChanged) {
                    const updatedCodes = [];
                    if (newCode) updatedCodes.push(newCode);
                    if (trimCodesStr) updatedCodes.push(trimCodesStr);
                    let finalCodesStr = updatedCodes.join('/');
                    finalCodesStr = finalCodesStr.replace(/^-/, '');
                    finalCodesStr = finalCodesStr.replace(/-$/, '');

                    const finalUrl = urlParts.slice(0, featuresIndex + 1).join('/') + `/${finalCodesStr}/`;
                    window.history.replaceState(null, null, finalUrl);
                }
            }
        }
    }, [trimCodes]);

    useEffect(() => {
        setVehicleModel(vehicleModels)
    }, [vehicleModels])

    useEffect(() => {
        setVehicleMake(vehiclesMakes)
    }, [vehiclesMakes]);

    useEffect(() => {
        setTrimModel(vehiclesTrim)
    }, [vehiclesTrim])

    useEffect(() => {
        setDriveType(vehicleTypes)
    }, [vehicleTypes])

    useEffect(() => {
        async function dispatchActions() {
            if (buttonClicked) {
                await dispatch(secondaryYears());
                if (vehicleData?.year) {
                    await dispatch(secondarySearch(vehicleData.year)).then(response => {
                        const vehiclesMakes = response.payload;

                        if (vehicleData?.make !== null || vehicleData?.make !== " " || vehicleData?.make !== undefined) {

                            dispatch(searchMake([vehicleData?.year, getKeyByValue(vehiclesMakes?.vehicles, vehicleData?.make)])).then(response => {
                                response.payload && dispatch(fetchTrimData(vehicleData?.modelCode))
                            });
                        }
                    });
                }
                setButtonClicked(false);
            }
        }

        dispatchActions();
    }, [buttonClicked]);

    useEffect(()=>{
        let exteriorColor, mediaColor = null

        if (setPrimaryAndSecondaryVehicles[0] && setPrimaryAndSecondaryVehicles[0]?.colors ){
            exteriorColor = setPrimaryAndSecondaryVehicles[0].colors.exteriors
            mediaColor = setPrimaryAndSecondaryVehicles[0].currentColor;
        }
        setPrimaryAndSecondaryVehicles[0] &&  dispatch(setColorName(getColorName(exteriorColor, mediaColor)))
    },[setPrimaryAndSecondaryVehicles[0] || setPrimaryAndSecondaryVehicles[0] && setPrimaryAndSecondaryVehicles[0]?.colors])

    const handleOptionModalClose = () => {
        setOptionsModal(false)
        showAddedEqu(null)
    }

    const removeVehicle = (vehicle, id) => {
        dispatch(setRemovedVehicle({code: vehicle.code,id: id}))
        trackRemovedVehicle(compareGroup)
    };

    const buildCompareforMobile = (vehicle, index) => {

        const {code, year, make, model, trim} = vehicle ?? {};
        const modelTrim = `${model ?? ''} ${trim ?? ''}`.trim();
        const yearMakeModelTrim = `${year ?? ''} ${make ?? ''} ${modelTrim}`.trim();
        const shouldMergeTitle = modelTrim.length > 30;

        const vehicleCTA = "https://www.jdpower.com/cars-for-sale/make-"+ make.toLowerCase() + "/model-" + model.toLowerCase().replace(/ /g, "-")
        if (index !== 0) {
            return (
                <Carousel.Item id={code}>
                    {
                        vehicle ?
                            <div className="competitor-vehicle-overview">
                                <div className={'clear-vehicle'}>
                                     <button
                                        type="button"
                                        className={"close-compare"}
                                        id={"features-vehicle-remove"}
                                        onClick={() => removeVehicle(vehicle)}
                                        disabled={isLocked && checkLockStatus(vehicle, isLocked,index)}
                                    >
                                        <CloseIcon fontSize={"medium"} />
                                    </button>
                                </div>
                                {getCompetitorImages(vehicle, activeLocale)}

                                <div className={"vehicle-detail"}>
                                    {shouldMergeTitle ? (
                                        <div className={"competitor-vehicle-yearMake competitor-vehicle-yearMake-merged"}>
                                            {yearMakeModelTrim}
                                        </div>
                                    ) : (
                                        <>
                                            <div className={"competitor-vehicle-yearMake"}>
                                                {year} {make}
                                            </div>
                                            <div className={"competitor-vehicle-yearMake"}>
                                                {model} {trim}
                                            </div>
                                        </>
                                    )}
                                    <div className={"price-start"}>
                                        <span>{t('overview.startingFrom')} </span>
                                        <span>  {vehicle && currencyConverter(vehicle?.pricing.msrp, activeLocale)}*</span>
                                    </div>
                                    {headerLoadType != null && (
                                        <div className={"vehicle-CTA"}>
                                            <a target="_blank" href={vehicleCTA}>See Cars For Sale</a>
                                        </div>
                                    )}
                                </div>
                            </div> :
                            <div className="competitor-vehicle-overview">
                                <div className="no-vehicle">{t('overview.noVehicleSelected')}</div>
                            </div>
                    }
                    <div className={"secondary-feature-controller"}>
                        <div className={"color-box-controller"}
                            style={{
                                left:  '-10px'
                            }}
                        >
                            <Color
                                primaryColor={
                                    vehicle?.colors?.exteriors
                                }
                                translate={t}
                                mediaColor={vehicle?.currentColor}
                                interiorColor = {vehicle?.colors?.interiors}
                            />
                        </div>
                        <div className={"secondaryvehicleController"}>
                            <button
                                id={index}
                                className={isLocked && checkLockStatus(vehicle, isLocked,index) ? "btn-default btn-change-disabled" : "btn-default btn-change-compare"}
                                value={vehicle}
                                onClick={(event) => changeHandler(event.target.id, vehicle)}
                                disabled={isLocked && isLocked[index]}
                            >
                                {vehicle ?
                                    t(
                                        'overview.changeSelectModal.change'): t('overview.controls.selectVehicle')}
                            </button>

                            <Change vehicleData={vehicleData}
                                    setVehicleData={setVehicleData}
                                    openModal={openModal}
                                    setOpenModal={setOpenModal}
                                    handleModalClose={handleChangeModalClose}
                                    years={secondaryYear}
                                    vehicleMake={vehicleMake}
                                    vehicleModels={vehicleModel}
                                    trimModel={trimModel}
                                    setTrimModel={setTrimModel}
                                    setVehicleModel={setVehicleModel}
                                    setVehicleMake={setVehicleMake}
                                    vehiclesTrim={vehiclesTrim}
                                    vehicleIndex={vehicleIndex}
                                    vehicleTypeName = {vehicleTypeName}
                                    driveType={driveType}
                                    setDriveType={setDriveType}
                                    lockedVehicle={isLocked}
                                    onReload={handleReload}
                            />

                            <LockCompetitor isLocked={isLocked}
                                            vehicle={vehicle}
                                            vehicleIndex = {index}
                                            trimCodes={trimCodes}
                                            toggleLock={() =>handleToggle(index,vehicle)} />
                        </div>
                    </div>
                </Carousel.Item>
            )
        }
    }

    function buildTablet(vehicle, index, hideSwapping) {
        const { year, make, model, trim } = vehicle ?? {};
        if (index !== 0 && index !== 1) {
            return (
                <Carousel.Item id={index}>
                    <div className="competitor-vehicle-overview">
                        <div className={"action-buttons"}>
                            {!hideSwapping && <button
                                type="button"
                                className="move-icon">
                                <FontAwesomeIcon icon={faUpDownLeftRight} />
                            </button>}
                            <button
                                type="button"
                                className={"close-compare"}
                                id={"features-vehicle-remove"}
                                onClick={() => removeVehicle(vehicle, index)}
                                disabled={isLocked && checkLockStatus(vehicle, isLocked,index)}
                            >
                                <CloseIcon fontSize={"medium"} />
                            </button>
                        </div>
                        {getCompetitorImages(vehicle, activeLocale)}
                        <div className={"vehicle-detail"}>
                            <div className={"competitor-vehicle-yearMake"}>
                                {year} {make}
                            </div>
                            <div className={"competitor-vehicle-yearMake"}>
                                {model} {trim}
                            </div>
                            <div className={"price-start"}>
                                {vehicle && <span>{t('overview.startingFrom')} </span>}
                                {vehicle && currencyConverter(vehicle?.pricing.msrp, activeLocale)}
                                {vehicle && <span>*</span>}
                            </div>
                        </div>
                    </div>
                    <div className={"secondary-feature-controller"}>
                        <div className={"color-box-controller"}
                            style={{
                                left: ['en-CA', 'en-US'].includes(activeLocale) ? '-10px' : '-9px',
                            }}
                        >

                            <Color
                                primaryColor={
                                    vehicle?.colors?.exteriors
                                }
                                translate={t}
                                mediaColor={vehicle?.currentColor}
                                interiorColor={vehicle?.colors?.interiors}
                            />
                        </div>
                        <div className={"secondaryvehicleController"}>
                            <button
                                id={index}
                                className={isLocked && checkLockStatus(vehicle, isLocked, index) ? "btn-default btn-change-disabled" : "btn-default btn-change-compare"}
                                value={vehicle}
                                onClick={(event) => changeHandler(event.target.id, vehicle)}
                                disabled={isLocked && isLocked[index]}
                                title={checkLockStatus(vehicle, isLocked, index) ? t("overview.changeSelectModal.vehicleLocked") : null}
                            >
                                {t('overview.changeSelectModal.change')}
                            </button>

                            <LockCompetitor isLocked={isLocked}
                                            vehicle={vehicle}
                                            vehicleIndex={index}
                                            trimCodes={trimCodes}
                                            toggleLock={() => handleToggle(index, vehicle)}
                            />

                            <Change vehicleData={vehicleData}
                                    setVehicleData={setVehicleData}
                                    openModal={openModal}
                                    setOpenModal={setOpenModal}
                                    handleModalClose={handleChangeModalClose}
                                    years={secondaryYear}
                                    vehicleMake={vehicleMake}
                                    vehicleModels={vehicleModel}
                                    trimModel={trimModel}
                                    setTrimModel={setTrimModel}
                                    setVehicleModel={setVehicleModel}
                                    setVehicleMake={setVehicleMake}
                                    vehiclesTrim={vehiclesTrim}
                                    vehicleIndex={vehicleIndex}
                                    vehicleTypeName={vehicleTypeName}
                                    driveType={driveType}
                                    setDriveType={setDriveType}
                                    lockedVehicle={isLocked}
                                    onReload={handleReload}
                            />
                        </div>
                    </div>
                </Carousel.Item>
            )
        }
    }

    const handleAccordionScroll = () => {
        let scrollPosition = window.pageYOffset;
        let container = document.querySelector(".feature-panel-category");
        let divs = container ? container.querySelectorAll('.accordion-menu') : [];
        const footer = document.querySelector(".footer-jdpa");

        for (let i = 0; i < divs.length; i++) {
            const currentDiv = divs[i];
            let divTop = currentDiv.offsetTop;
            let divBottom = (i < divs.length - 1)
                ? divs[i + 1].offsetTop
                : currentDiv.offsetTop + currentDiv.offsetHeight;

            if (scrollPosition + 410 >= divTop && scrollPosition + 400 < divBottom && !isMobile && !maxMobileHeight && !maxLaptopHeight) {
                dispatch(getActiveFeatureCategory(currentDiv.id));
                break;
            }

            if (isMobile && !maxMobileHeight) {
                if (scrollPosition + 160 >= divTop && scrollPosition + 150 < divBottom) {
                    dispatch(getActiveFeatureCategory(currentDiv.id));
                    break;
                }
                if (i === divs.length - 1 && footer && (scrollPosition + window.innerHeight >= footer.offsetTop - 10)) {
                    dispatch(getActiveFeatureCategory(currentDiv.id));
                    break;
                }
            }

            if (maxMobileHeight) {
                if (scrollPosition + 80 >= divTop && scrollPosition + 30 < divBottom) {
                    dispatch(getActiveFeatureCategory(currentDiv.id));
                    break;
                }
            }

            if (maxLaptopHeight && !maxMobileHeight) {
                if (scrollPosition + 320 >= divTop && scrollPosition + 200 < divBottom) {
                    dispatch(getActiveFeatureCategory(currentDiv.id));
                    break;
                }
            }
        }
    }

    function buildMissingCarousel(length, id) {
        const carouselItems = [];
        const targetLength = length <= 2 ? length : 1;

        for (let i = 0; i < targetLength; i++) {
            carouselItems.push(
                <Carousel.Item key={id + i} id={`${id}-${i}`}>
                    <div className="competitor-vehicle-overview no-competitor-overview">
                        <div className="no-vehicle">{t('overview.noVehicleSelected')}</div>
                    </div>
                    <div className={`change-modal ${headerLoadType === 'jdpa' ? 'change-modal-jdpa' : ''}`}>
                        <button
                            id={setPrimaryAndSecondaryVehicles.length + i}
                            className={`btn-default btn-change-compare ${(!setPrimaryAndSecondaryVehicles[0] ||
                                setPrimaryAndSecondaryVehicles[0].length === 0) ? ' disabled is-disabled' : ''}`}
                            value={""}
                            onClick={(event) => {
                                if (!setPrimaryAndSecondaryVehicles[0] || setPrimaryAndSecondaryVehicles[0].length === 0) {
                                    event.preventDefault();
                                    return;
                                }
                                changeHandler(setPrimaryAndSecondaryVehicles.length + i, "");
                            }}
                        >
                            {t('overview.controls.selectVehicle')}
                        </button>
                        <Change
                            vehicleData={vehicleData}
                            setVehicleData={setVehicleData}
                            openModal={openModal}
                            setOpenModal={setOpenModal}
                            handleModalClose={handleChangeModalClose}
                            years={secondaryYear}
                            vehicleMake={vehicleMake}
                            vehicleModels={vehicleModel}
                            trimModel={trimModel}
                            setTrimModel={setTrimModel}
                            setVehicleModel={setVehicleModel}
                            setVehicleMake={setVehicleMake}
                            vehiclesTrim={vehiclesTrim}
                            vehicleIndex={vehicleIndex}
                            vehicleTypeName={vehicleTypeName}
                            driveType={driveType}
                            setDriveType={setDriveType}
                            lockedVehicle={isLocked}
                            onReload={handleReload}
                        />
                    </div>
                </Carousel.Item>
            );
        }
        return carouselItems;
    }

    function onSearchFocus() {
        const searchInput = document.querySelector('#feature-search-input');
        const storedValue = sessionStorage.getItem('featureSearch');
        const searchIcon = document.getElementById('search-icon');
        const clearIcon = document.getElementById('clear-icon');

        if (searchInput.value.trim() !== '') {
            searchIcon.style.display = 'none';
            clearIcon.style.display = 'block';
        } else {
            searchIcon.style.display = 'block';
            clearIcon.style.display = 'none';
        }
        if (storedValue) {
            dispatch(getFeatuerSearch(storedValue));
            searchInput.value = storedValue;
        }

        searchInput.addEventListener('input', (e) => {
            const value = e.target.value.toLowerCase();
            if (value.length >= 2) {
                dispatch(getFeatuerSearch(value));
                trackFeatureSearchInput(compareGroup, value)
                sessionStorage.setItem('featureSearch', value);
            } else {
                dispatch(getFeatuerSearch(null));
                sessionStorage.removeItem('featureSearch');
            }
        });
    }

    function showDescription(feature) {
        if (feature.overview) {
            setDescription(feature.overview.description);
            setTitle(feature.overview.title);
            handleOpen()
        }
    }

    function showAdvantages(feature, allAdvantage) {
        if (allAdvantage==="true") {
            for (let i = 1; i < feature.comparisons.length; i++) {
                if (feature.comparisons[0]?.weight <= feature.comparisons[i]?.weight) {
                    return false;
                }
            }
            return true;
        }

        for (let i = 1; i < feature.comparisons.length; i++) {
            if (isMobile && (feature.comparisons[0]?.weight > feature.comparisons[activeVehicleIndex+1]?.weight)){
                return true
            }else {
                if (feature.comparisons[0]?.weight > feature.comparisons[i]?.weight) {
                    return true;
                }
            }
        }
    }

    function showOptions(options, index) {
        dispatch(setVehicleInfo({vehicleIndex:index,isDesktop: isDesktop}))
        setOptionsModal(true)
        showAddedEqu(options)
    }

    function isNonStandard(data) {
        if (data !== "" && data !== null) {
            return data?.isNonStandard;
        }
    }

    function showModifiedPackage(modifiedBy) {
        if (modifiedBy !== "" || modifiedBy !== null || modifiedBy !== undefined) {
            return modifiedBy;
        }
    }

    const hasChangeOptions = (data) => {
        return (data?.changeOptions)
    }

    function renderFeatureValue(compare, id, showOptions, index,label, categoryName) {
        if (id === 'pricing3' && compare?.value) {
            return (
                <div className={'feature-compare'}>
                    <div className={'compare-value'}>{compare.value}</div>
                    <div className={'feature-info'}>
                        <InfoIcon fontSize={"small"} onClick={() => { showOptions(compare.options, index) }} />
                    </div>
                </div>
            );
        } else {
            return showFeatureValue(compare?.value, isNonStandard(compare?.data), hasChangeOptions(compare?.data), label, index, showModifiedPackage(compare?.data?.modifiedBy), categoryName);
        }
    }

    function renderEmptyCells(count) {
        if (count === 2) {
            return (
                <td key={`empty-cell-2`} className={"feature-value"}>{" "}</td>
            );
        } else {
            return [...Array(count)].map((_, i) => (
                <td key={`empty-cell-${i}`} className={"feature-value"}>{" "}</td>
            ));
        }
    }

    const handleMouseEnter = (options, vehicle, dispatch, index, value) => {
        setTooltipLoading(true);
        setHoveredIndex(index);
        setTooltipText('');
        let featureValue = value.toLowerCase();
        const excludedValues = ["no", "non", "aucun", "none"];

            getIccCode(options, vehicle, dispatch, index)
                .then((response) => {
                    if (((response && response[0]?.error?.code) && !excludedValues.includes(featureValue)) || (response && response[0]?.error?.code)) {
                        setTooltipText(t('features.alternateFeature'));
                    } else if (excludedValues.includes(featureValue)) {
                        setTooltipText(t('features.alternateTrimsOptions'));
                    } else{
                        setTooltipText(t('features.alternateFeature'));
                    }
                    setTooltipLoading(false);
                })
                .catch(() => {
                    setHoveredIndex(null);
                });
    };

    const handleMouseLeave = () => {
        setHoveredIndex(null);
        setTooltipText('');
        setTooltipLoading(false);
    };

    function showFeatureValue(value, data, changeOptions,label,index, modifiedPackage, categoryName) {
        if (!value) return "---";

        return (
            <React.Fragment>
                <div className={changeOptions ? "alternative-feature flex-layout" : ""}>
                    <span className={data ? "feature-non-standard" : modifiedPackage && data ? "modified-package-container" : ""}>{value}
                        {data && !isMobile && !modifiedPackage &&
                            <div className="tooltip-modal">
                                {t('features.comparisons.featureModified')}
                            </div>
                        }

                        {data && !isMobile && modifiedPackage && (
                            <div className={`tooltip-modal ${data && !isMobile && modifiedPackage ? 'package-tooltip' : ''}`}>
                                {activeLocale === 'fr-CA' ? (
                                        <span className="modified-package-name">{modifiedPackage}
                                            {t('features.comparisons.equipmentModified')}
                                        </span>

                                ) : (
                                    <span className="modified-package-name">
                                        {t('features.comparisons.equipmentModified')}
                                        {modifiedPackage}
                                    </span>
                                )}
                            </div>
                        )}

                    </span>
                    {changeOptions && (
                        <span
                            className="alternate-feature"
                            onClick={() => {
                                displayModal(changeOptions, label, index,setPrimaryAndSecondaryVehicles[index], value, categoryName)}}
                            onMouseEnter={() =>
                                handleMouseEnter(changeOptions, setPrimaryAndSecondaryVehicles[index], dispatch, index, value)}
                            onMouseLeave={handleMouseLeave}
                        >
                        <FontAwesomeIcon icon={faCaretRight} />
                            {!isMobile && hoveredIndex === index && !tooltipLoading && tooltipText && (
                                <span className="custom-tooltip">{tooltipText}</span>
                            )}
                        </span>
                    )}
                </div>
            </React.Fragment>
        );
    }

    function showAvailableFeature(feature, id, categoryName) {
        return (
            <React.Fragment>
                <MediaQuery minWidth={479}>
                    <tr className={"feature-row" + (id === 'pricing4' ? ' pricing-row' : '')}>
                        <td className={"feature-label"}
                            onClick={
                                () => {
                                    showDescription(feature)
                                }

                            }>
                            {feature.overview ? (
                                <div className={'feature-overview'}>{feature.label} </div>
                            ) : (
                                feature.label
                            )}
                            <span className={"advantage-icon"}>
                                 {showAdvantages(feature, allAdvantage) ? <CheckCircleIcon fontSize={"small"}/> : null}
                             </span>
                        </td>

                        <MediaQuery minWidth={899}>
                            {feature.comparisons.map((compare, index) => (
                                <td key={index} className={"feature-value"}>
                                    {renderFeatureValue(compare, id, showOptions, index, feature?.label, categoryName)}
                                </td>
                            ))}
                            {[...Array(Math.max( 0,4 - feature.comparisons.length))].map((_, i) => (
                                <td key={`empty-cell-${i}`} className={"feature-value"}>{" "}</td>
                            ))}
                        </MediaQuery>

                        <MediaQuery minWidth={720} maxWidth={899}>
                            <td className={"feature-value"}>{renderFeatureValue(feature?.comparisons[0],id,showOptions,0,feature?.label, categoryName)}</td>
                            <td className={"feature-value"}>{renderFeatureValue(feature?.comparisons[1],id,showOptions,1,feature?.label, categoryName)}</td>
                            {feature.comparisons
                                .filter((value, index) => index === (activeVehicleIndex + 2))
                                .map((compare, index) => (
                                    <td key={`row-${index}`} className={"feature-value"}>
                                        {renderFeatureValue(compare, id, showOptions, activeVehicleIndex+2,feature?.label, categoryName)}
                                    </td>
                                ))}
                            {!feature.comparisons.filter((value, index) => index === (activeVehicleIndex + 2)).length &&
                            renderEmptyCells(Math.max(0, 4 - feature.comparisons.length))}
                        </MediaQuery>

                        <MediaQuery minWidth={320} maxWidth={719}>
                            <td className={"feature-value"}>{showFeatureValue(feature.comparisons[0]?.value)}</td>
                            {feature.comparisons
                                .filter((value, index) => index === (activeVehicleIndex + 1))
                                .map((compare, index) => (
                                    <td key={`row-mobile-${index}`} className={"feature-value"}>
                                        {renderFeatureValue(compare, id, showOptions, index,feature?.label, categoryName)}
                                    </td>
                                ))}
                            {!feature.comparisons.filter((value, index) => index === (activeVehicleIndex + 1)).length &&
                            renderEmptyCells(Math.max(0, 4 - feature.comparisons.length))}
                        </MediaQuery>
                    </tr>
                </MediaQuery>

                <MediaQuery minWidth={320} maxWidth={478}>
                    <tr className={"feature-row"}>
                        <th colSpan={2} className={"feature-label"}
                            onClick={
                                () => {
                                    showDescription(feature)
                                }
                            }>
                            {feature.overview ? (
                                <div className={'feature-overview'}>{feature.label} </div>
                            ) : (
                                feature.label
                            )}
                        </th>
                    </tr>
                    <MediaQuery minWidth={320} maxWidth={719}>
                        <tr className={"feature-row"}>
                            <td className={"feature-value"}>
                                {feature.comparisons[0]?.value}{" "}
                                {showAdvantages(feature, allAdvantage) ? <CheckCircleIcon fontSize={"small"} /> : null}
                            </td>
                            {feature.comparisons.map((compare, index) => {
                                if (index === activeVehicleIndex + 1) {
                                    return (
                                        <td key={`${index}`} className={"feature-value"}>
                                            {renderFeatureValue(compare, id, showOptions, index, feature.label, categoryName)}
                                        </td>
                                    );
                                }
                                return null;
                            })}
                            {!feature.comparisons.filter((value, index) => index === (activeVehicleIndex + 1)).length &&
                            renderEmptyCells(Math.max(0, 3 - feature.comparisons.length))}
                        </tr>
                    </MediaQuery>
                </MediaQuery>
            </React.Fragment>
        );
    }

    function showAllFeature(features) {
        return features.featureRows.map((feature) =>
            showAvailableFeature(feature, feature.id, features?.name))
    }

    function isAlwaysOpen() {
        setAlwaysOpen((isExpanded = !isExpanded));
        if (isExpanded) {
            setExpandedArr([]);
            dispatch(setCategories({panel:"all", newExpanded:false,isAllExpanded: true}))
            trackCollapseAllHandler(compareGroup)
            const expandAll = "EXPAND ALL"
            dispatch(setButtonHandlerText(expandAll));
            try {
                sessionStorage.setItem('isExpanded', true);
                sessionStorage.setItem('expandedArr', JSON.stringify([]));
            } catch (error) {
                console.error(error);
            }
        } else {
            setExpandedArr(featuresLabel);
            dispatch(setCategories({panel:"all", newExpanded:true,isAllExpanded: true}))
            trackExpandAllHandler(compareGroup)
            const collapseAll = "COLLAPSE ALL"
            dispatch( setButtonHandlerText(collapseAll));
            try {
                sessionStorage.setItem('isExpanded', false);
                sessionStorage.setItem('expandedArr', JSON.stringify(featuresLabel));
            } catch (error) {
            }
        }
    }

    const handleToggleMenu =() => {
        setShowNav(!showNav)
        setChecked(true)
    }
    const [vehicleList, setVehicleList] = useState([]);
    const [isDraggingOutside, setIsDraggingOutside] = useState(null);

    useEffect(() => {
        setVehicleList(setPrimaryAndSecondaryVehicles.slice(1));
    }, [setPrimaryAndSecondaryVehicles])

    const handleDragEnd = (result) => {
        const { destination, source } = result;
        if (!destination) return;
        if (destination.index === source.index) return;

        const items = Array.from(vehicleList);
        const [removed] = items.splice(source.index, 1);
        items.splice(destination.index, 0, removed);

        setVehicleList(items);
        const updatedListWithPrimary = [setPrimaryAndSecondaryVehicles[0], ...items];
        const vehicleCodes = updatedListWithPrimary.map((vehicle) => ({ code: vehicle?.code }));
        const data = {
            code: vehicleCodes,
            exterior: colorCode || null,
        };
        dispatch(vehicleHasSwapped(true))
        dispatch(updateVehicleOrder(updatedListWithPrimary))
        dispatch(PostcompareData(data)).then((response) => {
            const error = response?.payload?.statusCode
            if (!response?.error && response?.payload?.vehicles) {
                const newCompareGroup = getCompareGroupData(response.payload.vehicles, error, compareGroup);
                dispatch(setCompareGroupData(newCompareGroup));
                trackVehiclePositionChanged(newCompareGroup);
            }
        });
    };

    const handleDragUpdate = (update) => {
        const { destination, draggableId } = update;
        const container = document.querySelector('.competitor-vehicle-container');

        if (destination == null) {
            setIsDraggingOutside(true);
        } else {
            const draggedElement = document.getElementById(draggableId);
            const draggedElementRect = draggedElement.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();

            if (
                draggedElementRect.left < containerRect.left ||
                draggedElementRect.right > containerRect.right
            ) {
                setIsDraggingOutside(true);
            } else {
                setIsDraggingOutside(false);
            }
        }
    };

    const handleDragComplete = (result) => {
        const { destination, source } = result;

        if (!destination) {
            return;
        }

        if (destination.index === source.index) {
            return;
        }

        const updatedVehicles = Array.from(setPrimaryAndSecondaryVehicles);
        const [removed] = updatedVehicles.splice(source.index, 1);
        updatedVehicles.splice(destination.index, 0, removed);
        dispatch(updateVehicleOrder(updatedVehicles));
    };

    const handleDragProgress = (update) => {
        const { destination, source } = update;

        // You can handle the drag progress here (like highlighting or any other updates
        if (destination && destination.index !== source.index) {
            // Add logic to change visual feedback, if needed
        }
    };

    return (
        <React.Fragment>
            <MediaQuery minWidth={1200}>
                <Navbar
                    leftChildren={
                        <React.Fragment>
                            <button className={"btn-compare feature-active"}>{t('navigation.features')}</button>
                            <button
                                className={`btn-compare feature-not-active ${headerLoadType && 
                                           (!setPrimaryAndSecondaryVehicles[0] || setPrimaryAndSecondaryVehicles[0].length === 0) ? 'disabled-active-tab' : '' }`}
                                id={"nav-photo-button"}
                                onClick={() => navigatePhotos()}
                                disabled={!setPrimaryAndSecondaryVehicles[0] || setPrimaryAndSecondaryVehicles[0].length === 0}
                                style={{
                                    cursor: (!setPrimaryAndSecondaryVehicles[0] || setPrimaryAndSecondaryVehicles[0].length === 0) ? "not-allowed" : "pointer",
                                    color: (!setPrimaryAndSecondaryVehicles[0] || setPrimaryAndSecondaryVehicles[0].length === 0) ? "#999999" : undefined
                                }}
                            >
                                {t('navigation.photos')}
                            </button>
                        </React.Fragment>
                    }
                    rightChildren={
                        <React.Fragment>
                            {headerLoadType != null ? (
                                <NavbarBtn />
                            ) : (
                                <NavbarBtn compareTrim={compareTrim} />
                            )}
                        </React.Fragment>
                    }
                />
            </MediaQuery>
            <MediaQuery minWidth={320} maxWidth={479}>
                <div className={`navbar-overview ${isFixed ? 'fixed-position' : 'navbar-position'}`}>
                    <Navbar
                        leftChildren={
                            <React.Fragment>
                                {showMobileNav(navigatePhotos,compareTrim,t,pathname, showNav,checked, handleToggleMenu, headerLoadType, setPrimaryAndSecondaryVehicles)}
                            </React.Fragment>
                        }
                        rightChildren={
                            <React.Fragment>
                                <NavbarBtn
                                    compareTrim={compareTrim}
                                    singularButton={headerLoadType !== null}/>
                            </React.Fragment>
                        }
                        isMobile={isMobile}
                    />
                </div>
            </MediaQuery>
            <MediaQuery minWidth={479} maxWidth={1199}>
                <div className={`navbar-overview ${isFixed ? 'fixed-position' : 'navbar-position'}`}>

                    <Navbar
                        leftChildren={
                            <React.Fragment>
                                {showMobileNav(navigatePhotos,compareTrim,t,pathname, showNav,checked, handleToggleMenu, headerLoadType)}
                            </React.Fragment>
                        }
                        rightChildren={
                            <React.Fragment>
                                <NavbarBtn
                                    compareTrim={compareTrim}/>
                            </React.Fragment>
                        }
                    />
                </div>
            </MediaQuery>
            {loading  ? (
                <Loader/>): ( <>
                <React.Fragment>
                    <BasicModal open={open} onClose={handleClose} disableScrollLock={false}>
                        <div className={"description-modal"}>
                            <div className={"description-title"}>
                                <div className={"description-title-div"}> {title} </div>
                                <button
                                    type="button"
                                    className={"close-compare"}
                                    onClick={handleClose}
                                    role={'dialog'}
                                >
                                    <CloseIcon fontSize={"small"}/>
                                </button>
                            </div>
                            <div className={"description-body"}>
                                <p className={"description-body-div"}> {description} </p>
                            </div>
                        </div>
                    </BasicModal>
                </React.Fragment>

                <React.Fragment>
                    <BasicModal open={isModalVisible} onClose={hideModal}>
                        <div className={"description-modal"}>
                            <div className={"description-title"}>
                                <div className={"description-title-div"}> {vehicleName} </div>
                                <button
                                    type="button"
                                    className={"close-compare"}
                                    onClick={hideModal}
                                    role={'dialog'}
                                >
                                    <CloseIcon fontSize="small"/>
                                </button>
                            </div>
                            <div className={"description-body"}>
                                <div className={"description-body-container"}>
                                    <p className={"feature-label"}>{`${category} - ${featureLabel} - ${featureValue}`}</p>
                                    <p className={"option-label"}> {t('features.otherOptions')} </p>
                                    <div className={"description-body-div"}>
                                        {changeOptions !== null && showSingleFeature(changeOptions, activeLocale, vehiclesTrim, setPrimaryAndSecondaryVehicles,trimIndex,
                                            dispatch, colorCode, setIsModalVisible, isLocked, featureVehicleLocked, t)}
                                    </div>
                                </div>
                            </div>
                            <div className="feature-modal-footer">
                                <div className="btn-default" onClick={hideModal}>
                                    {t('close')}
                                </div>
                            </div>
                        </div>
                    </BasicModal>
                </React.Fragment>

                <div className={"navbar-overview"}>
                    <div className={"navbar-container"}>
                        <div className={"overView"}>
                            <div className={"feature-container"}>
                                <MediaQuery minWidth={320} >
                                {<PrimaryVehicle
                                    vehicleData={vehicleData}
                                    setVehicleData={setVehicleData}
                                    openModal={openModal}
                                    setOpenModal={setOpenModal}
                                    secondaryYear={secondaryYear}
                                    vehiclesMakes={vehicleMake}
                                    vehicleModel={vehicleModel}
                                    trimModel={trimModel}
                                    setTrimModel={setTrimModel}
                                    setVehicleMake={setVehicleMake}
                                    vehiclesTrim={vehiclesTrim}
                                    vehicleIndex={vehicleIndex}
                                    vehicleTypeName={vehicleTypeName}
                                    driveType={driveType}
                                    isLocked={isLocked}
                                    handleReload={handleReload}
                                    headerLoadType={headerLoadType}
                                    t={t}
                                    setDriveType={setDriveType}
                                    competitorLength={competitorLength}
                                    activeLocale={activeLocale}
                                    removeVehicle={removeVehicle}
                                    setPrimaryAndSecondaryVehicles={setPrimaryAndSecondaryVehicles}
                                    trimCodes={trimCodes}
                                    handleToggle={handleToggle}
                                    changeHandler={changeHandler}
                                    handleChangeModalClose={handleChangeModalClose}
                                    isFeatureChecked={isFeatureChecked}
                                    isAdvantageChecked={isAdvantageChecked}
                                    compareGroup={compareGroup}
                                    isAlwaysOpen={isAlwaysOpen}
                                    expandHandlerText={expandHandlerText}
                                    collapseHandlerText={collapseHandlerText}
                                    isExpanded={isExpanded}
                                    isDifferenceOnly={isDifferenceOnly}
                                    hideDiv={hideDiv}
                                    handleAccordionScroll={handleAccordionScroll}
                                    activeFeatureLabel={activeFeatureLabel}
                                    dispatch={dispatch}
                                    onSearchFocus={onSearchFocus}
                                    hideImages={hideImages}
                                    hideButtons={hideButtons}
                                />
                                }
                            </MediaQuery>
                            {  <MediaQuery minWidth={900}>
                                { setPrimaryAndSecondaryVehicles.length > 0 && <div className="parent-container">
                                    <DragDropContext onDragEnd={handleDragEnd} onDragUpdate={handleDragUpdate}>
                                        <Droppable droppableId="competitor-vehicle-container" direction="horizontal">
                                            {(provided, snapshot) => (
                                                <div
                                                    className={`competitor-vehicle-container ${isDraggingOutside ? 'not-allowed' : ''}`}
                                                    ref={provided.innerRef}
                                                    {...provided.droppableProps}
                                                >
                                                    {  vehicleList.map((vehicle, index) => (
                                                        <Draggable key={index} draggableId={index.toString()}
                                                                   index={index}>
                                                            {(provided, snapshot) => {
                                                                const isDragging = snapshot.isDragging;
                                                                return (
                                                                    <div
                                                                        className={`competitor-vehicle${hideImages ? ' images-hidden' : ''} ${isDragging ? 'card-dragging' : ''}`}
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        id={index.toString()}
                                                                    >
                                                                        <SecondaryCompetitors
                                                                            vehicle={vehicle}
                                                                            index={index + 1}
                                                                            activeLocale={activeLocale}
                                                                            vehicleData={vehicleData}
                                                                            setVehicleData={setVehicleData}
                                                                            openModal={openModal}
                                                                            setOpenModal={setOpenModal}
                                                                            secondaryYear={secondaryYear}
                                                                            vehiclesMakes={vehicleMake}
                                                                            vehicleModel={vehicleModel}
                                                                            trimModel={trimModel}
                                                                            setTrimModel={setTrimModel}
                                                                            setVehicleMake={setVehicleMake}
                                                                            vehiclesTrim={vehiclesTrim}
                                                                            vehicleIndex={vehicleIndex}
                                                                            vehicleTypeName={vehicleTypeName}
                                                                            driveType={driveType}
                                                                            isLocked={isLocked}
                                                                            handleReload={handleReload}
                                                                            removeVehicle={removeVehicle}
                                                                            t={t}
                                                                            headerLoadType={headerLoadType}
                                                                            setDriveType={setDriveType}
                                                                            setVehicleModel={setVehicleModel}
                                                                            handleModalClose={handleClose}
                                                                            changeHandler={changeHandler}
                                                                            trimCodes={trimCodes}
                                                                            handleToggle={handleToggle}
                                                                            hideImages={hideImages}
                                                                            hideButtons={hideButtons}
                                                                        />
                                                                    </div>
                                                                );
                                                            }}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                </div>}
                                {setPrimaryAndSecondaryVehicles.length < 4 && <BuildMissingCompetitors
                                    t={t}
                                    vehicleData={vehicleData}
                                    setVehicleData={setVehicleData}
                                    openModal={openModal}
                                    setOpenModal={setOpenModal}
                                    secondaryYear={secondaryYear}
                                    vehiclesMakes={vehicleMake}
                                    vehicleModel={vehicleModel}
                                    trimModel={trimModel}
                                    setTrimModel={setTrimModel}
                                    setVehicleMake={setVehicleMake}
                                    vehiclesTrim={vehiclesTrim}
                                    vehicleIndex={vehicleIndex}
                                    vehicleTypeName={vehicleTypeName}
                                    driveType={driveType}
                                    isLocked={isLocked}
                                    handleReload={handleReload}
                                    setPrimaryAndSecondaryVehicles={setPrimaryAndSecondaryVehicles.length === 0 ? [null] : setPrimaryAndSecondaryVehicles}
                                    handleModalClose={handleChangeModalClose}
                                    changeHandler={changeHandler}
                                    setVehicleModel={setVehicleModel}
                                    setDriveType={setDriveType}
                                    hideButtons={hideButtons}
                                    headerLoadType={headerLoadType}
                                />}

                            </MediaQuery> }

                                <MediaQuery minWidth={720} maxWidth={899} minHeight={500}>
                                    <div className="parent-container">
                                        <DragDropContext
                                            onDragEnd={handleDragComplete}
                                            onDragUpdate={handleDragProgress}
                                        >
                                            <Droppable droppableId="competitor-vehicle-container" direction="horizontal">
                                                {(provided, snapshot) => (
                                                    <div
                                                        className={`competitor-vehicle-container ${isDraggingOutside ? 'not-allowed' : ''}`}
                                                        ref={provided.innerRef}
                                                        {...provided.droppableProps}
                                                    >
                                                        {/* Render first secondary if it exists */}
                                                        {
                                                            <Draggable key={setPrimaryAndSecondaryVehicles[1]?.code}
                                                                       draggableId={setPrimaryAndSecondaryVehicles[1]?.code}
                                                                       index={1}>
                                                                {(provided, snapshot) => {
                                                                    const isDragging = snapshot.isDragging;
                                                                    return (
                                                                        <div
                                                                            className={`competitor-vehicle${hideImages ? ' images-hidden' : ''} ${isDragging ? 'card-dragging' : ''}`}
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                            id={setPrimaryAndSecondaryVehicles[1]?.code}
                                                                        >
                                                                            <FirstCompetitor
                                                                                vehicle={setPrimaryAndSecondaryVehicles[1]}
                                                                                activeLocale={activeLocale}
                                                                                t={t}
                                                                                currencyConverter={currencyConverter}
                                                                                isLocked={isLocked}
                                                                                checkLockStatus={checkLockStatus}
                                                                                removeVehicle={removeVehicle}
                                                                                changeHandler={changeHandler}
                                                                                handleToggle={handleToggle}
                                                                                handleChangeModalClose={handleChangeModalClose}
                                                                                vehicleData={vehicleData}
                                                                                setVehicleData={setVehicleData}
                                                                                openModal={openModal}
                                                                                setOpenModal={setOpenModal}
                                                                                secondaryYear={secondaryYear}
                                                                                vehiclesMakes={vehicleMake}
                                                                                vehicleModel={vehicleModel}
                                                                                trimModel={trimModel}
                                                                                setTrimModel={setTrimModel}
                                                                                setVehicleModel={setVehicleModel}
                                                                                setVehicleMake={setVehicleMake}
                                                                                vehiclesTrim={vehiclesTrim}
                                                                                vehicleIndex={vehicleIndex}
                                                                                vehicleTypeName={vehicleTypeName}
                                                                                driveType={driveType}
                                                                                setDriveType={setDriveType}
                                                                                buildTablet={buildTablet}
                                                                                buildMissingCarousel={buildMissingCarousel}
                                                                                getCompetitorImages={getCompetitorImages}
                                                                                trimCodes={trimCodes}
                                                                                dispatch={dispatch}
                                                                                getCarouselIndexKey={getCarouselIndexKey}
                                                                                hideButtons={hideButtons}
                                                                            />
                                                                        </div>
                                                                    );
                                                                }}
                                                            </Draggable>}

                                                        {/* Render second secondary if it exists */}
                                                        {
                                                            <Draggable key={setPrimaryAndSecondaryVehicles[2]?.code}
                                                                       draggableId={setPrimaryAndSecondaryVehicles[2]?.code}
                                                                       index={2}>
                                                                {(provided, snapshot) => {
                                                                    const isDragging = snapshot.isDragging;
                                                                    return (
                                                                        <div
                                                                            className={`competitor-vehicle${hideImages ? ' images-hidden' : ''} ${isDragging ? 'card-dragging' : ''}`}
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                            id={setPrimaryAndSecondaryVehicles[2]?.code}
                                                                        >
                                                                            <CarouselCompetitor
                                                                                setPrimaryAndSecondaryVehicles={setPrimaryAndSecondaryVehicles}
                                                                                setSecondaryVehicles={setSecondaryVehicles}
                                                                                activeLocale={activeLocale}
                                                                                t={t}
                                                                                currencyConverter={currencyConverter}
                                                                                isLocked={isLocked}
                                                                                checkLockStatus={checkLockStatus}
                                                                                removeVehicle={removeVehicle}
                                                                                changeHandler={changeHandler}
                                                                                handleToggle={handleToggle}
                                                                                handleChangeModalClose={handleChangeModalClose}
                                                                                vehicleData={vehicleData}
                                                                                setVehicleData={setVehicleData}
                                                                                openModal={openModal}
                                                                                setOpenModal={setOpenModal}
                                                                                secondaryYear={secondaryYear}
                                                                                vehiclesMakes={vehicleMake}
                                                                                vehicleModel={vehicleModel}
                                                                                trimModel={trimModel}
                                                                                setTrimModel={setTrimModel}
                                                                                setVehicleModel={setVehicleModel}
                                                                                setVehicleMake={setVehicleMake}
                                                                                vehiclesTrim={vehiclesTrim}
                                                                                vehicleIndex={vehicleIndex}
                                                                                vehicleTypeName={vehicleTypeName}
                                                                                driveType={driveType}
                                                                                setDriveType={setDriveType}
                                                                                buildTablet={buildTablet}
                                                                                buildMissingCarousel={buildMissingCarousel}
                                                                                getCompetitorImages={getCompetitorImages}
                                                                                trimCodes={trimCodes}
                                                                                dispatch={dispatch}
                                                                                getCarouselIndexKey={getCarouselIndexKey}
                                                                            />
                                                                        </div>
                                                                    );
                                                                }}
                                                            </Draggable>}

                                                        {provided.placeholder}
                                                    </div>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    </div>
                                </MediaQuery>

                            <MediaQuery minWidth={720} maxWidth={899} maxHeight={499}>
                                <LandscapeCompetitorView
                                    setPrimaryAndSecondaryVehicles={setPrimaryAndSecondaryVehicles}
                                    setSecondaryVehicles={setSecondaryVehicles}
                                    isLocked={isLocked}
                                    checkLockStatus={checkLockStatus}
                                    removeVehicle={removeVehicle}
                                    getCompetitorImages={getCompetitorImages}
                                    activeLocale={activeLocale}
                                    t={t}
                                    currencyConverter={currencyConverter}
                                    changeHandler={changeHandler}
                                    trimCodes={trimCodes}
                                    handleToggle={handleToggle}
                                    vehicleData={vehicleData}
                                    setVehicleData={setVehicleData}
                                    openModal={openModal}
                                    setOpenModal={setOpenModal}
                                    handleChangeModalClose={handleChangeModalClose}
                                    secondaryYear={secondaryYear}
                                    vehiclesMakes={vehicleMake}
                                    vehicleModel={vehicleModel}
                                    trimModel={trimModel}
                                    setTrimModel={setTrimModel}
                                    setVehicleModel={setVehicleModel}
                                    setVehicleMake={setVehicleMake}
                                    vehiclesTrim={vehiclesTrim}
                                    vehicleIndex={vehicleIndex}
                                    vehicleTypeName={vehicleTypeName}
                                    driveType={driveType}
                                    setDriveType={setDriveType}
                                    dispatch={dispatch}
                                    getCarouselIndexKey={getCarouselIndexKey}
                                    buildTablet={buildTablet}
                                    buildMissingCarousel={buildMissingCarousel}
                                />
                            </MediaQuery>

                            <MediaQuery maxWidth={719}>
                                <div className={"competitor-vehicle"}>
                                    <Carousel
                                        indicators={isMobile && setPrimaryAndSecondaryVehicles.length > 1}
                                        interval={null}
                                        controls={false}
                                        activeIndex={activeVehicleIndex}
                                        onSelect={(eventKey, event) => dispatch(getCarouselIndexKey(eventKey))}
                                    >
                                        {setSecondaryVehicles.map((vehicle,index) => {
                                            return buildCompareforMobile(vehicle,index)
                                        })}

                                        { setPrimaryAndSecondaryVehicles?.length === 0 && buildMissingCarousel(3, "3") }
                                        { setSecondaryVehicles.length === 3 && buildMissingCarousel(setSecondaryVehicles.length, "3") }
                                        { setSecondaryVehicles.length === 2 && buildMissingCarousel(setSecondaryVehicles.length, "2") }
                                        { setSecondaryVehicles.length === 1 && buildMissingCarousel(setSecondaryVehicles.length, "1") }

                                    </Carousel>
                                </div>
                            </MediaQuery>
                            <MediaQuery minWidth={320} maxWidth={479}>
                                <StickyNavbar primaryVehicle={setPrimaryAndSecondaryVehicles[0]} secondaryVehicle={secondaryVehicle}/>
                            </MediaQuery>
                        </div>
                    </div>
                    {setPrimaryAndSecondaryVehicles.length ? (
                        <FilterToolbar
                            isFeatureChecked={isFeatureChecked}
                            isAdvantageChecked={isAdvantageChecked}
                            onAdvantageClick={(e) => {
                                dispatch(setAdvantagesCheck(e.target.checked))

                                if (e.target.checked === true){
                                    trackAdvantagesChecked(compareGroup)
                                }else if (e.target.checked === false){

                                    trackAdvantagesUnChecked(compareGroup)
                                }
                            }
                            }
                            onFeatureClick={(event) =>
                                dispatch(setCheckedFeature(event.target.checked))
                            }
                            onSearchFocus={onSearchFocus}
                            setCheckedFeature={setCheckedFeature}
                            alwaysOpen={isAlwaysOpen}
                            buttonHandlerText={isExpanded}
                            translate={t}
                            expandButtonText={expandHandlerText}
                            collapseButtonText={collapseHandlerText}
                            onFilterClick = {(event) => dispatch(setDifferenceOnly(event.target.checked))}
                            isFilterChecked = {isDifferenceOnly}
                        />
                    ) : null}

                    {!hideDiv && <div id={'feature-fixed-header '} className={'feature-segment-label'}>
                        <div className={'header-title'}>
                            {window.onscroll = handleAccordionScroll} {activeFeatureLabel}
                        </div>
                    </div>}
                    </div>
                </div>
                <div className={"feature-list"}>
                    <div className={"feature-list-container"}>
                        { setFeatureLabel && Object.keys(setFeatureLabel)?.length ?<FeatureTable
                            isFeatureChecked={isFeatureChecked}
                            isAdvantageChecked={isAdvantageChecked}
                            setFeatureLabel={setFeatureLabel}
                            showAllFeature={showAllFeature}
                            featureSearched={searchedFeature}
                            alwaysOpen={isExpanded}
                            handleChange={handleChange}
                            featuresLabel={featuresLabel}
                            hasDisclaimer ={hasDisclaimer}
                        />  :
                            <div id={'feature-empty-vehicle-list'} className={'feature-empty-vehicle-list'}>
                                { setPrimaryAndSecondaryVehicles?.length !== 0 &&
                                    <p>{t('features.comparisons.emptyVehicleList')}</p>
                                }
                        </div>}
                    </div>
                </div>

                <BasicModal
                    open={openOptionsModal}
                    onClose={handleOptionModalClose}
                    role={'dialog'}
                >
                    <div className={"equipment-modal"}>
                        <div className={"description-title"}>
                            <div className="description-container">
                                <button
                                    type="button"
                                    className={"close-compare"}
                                    onClick={handleOptionModalClose}
                                >
                                    <CloseIcon fontSize={"small"}/>
                                </button>
                                <div className={"description-title-div"}>
                                    {t('features.comparisons.addedEquipmentModal.title')}
                                </div>
                            </div>

                        </div>
                        <div className={"description-body"}>
                            <p className={"description-body-div"}>
                                {t('features.comparisons.addedEquipmentModal.heading')} {getVehicleInfo?.year} {getVehicleInfo?.model}
                            </p>
                            <table className={"grid-container"}>
                                <tbody>
                                {addedEquipment && addedEquipment.map((options,index) => (
                                    <tr className={"grid-row"} key={`${index}`}>
                                        <td className={"grid-cell"}>{t(options.description)}</td>
                                        <td className={"grid-cell"}>{priceFormatter(options.value)}</td>
                                    </tr>
                                ))}
                                <tr className={"grid-row"}>
                                    <td className={"grid-cell"}> {t('features.comparisons.addedEquipmentModal.total')} </td>
                                    <td className={"grid-cell"}>
                                        {Array.isArray(addedEquipment)
                                            ? priceFormatter(addedEquipment.reduce((total, option) => total + parseFloat(option.value), 0))
                                            : 'N/A'}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </BasicModal>
            </>)}
        </React.Fragment>
    );
};

export default Compare;
